<template>
  <a-layout-sider class="sider">
    <a-menu v-model:selectedKeys="selectedKeys" mode="inline" class="menu">
      <a-menu-item v-for="item in menuItems" :key="item.key" style="text-align: left;">
        <component :is="item.icon" /> {{ item.label }}
      </a-menu-item>
    </a-menu>
  </a-layout-sider>
  <main class="content-scroll">
    <component :is="menuItems.find(item => item.key === selectedKeys[0]).component" />
  </main>
</template>

<script setup>
import { ref } from 'vue';
import { BarChartOutlined, ApartmentOutlined, RiseOutlined, OrderedListOutlined, ReadOutlined } from '@ant-design/icons-vue';

import ContributorOverview from './ContributorOverview.vue';
import ContributorFields from './ContributorFields.vue';
import ContributorActivity from './ContributorActivity.vue';
import ContributorLeaderboard from './ContributorLeaderboard.vue';
import DeveloperStories from './DeveloperStories.vue';

const selectedKeys = ref(['1']);

const menuItems = [
  { key: '1', icon: BarChartOutlined, label: '概览', component: ContributorOverview },
  { key: '2', icon: ApartmentOutlined, label: '领域分析', component: ContributorFields },
  { key: '3', icon: RiseOutlined, label: '活跃度分析', component: ContributorActivity },
  { key: '4', icon: OrderedListOutlined, label: '贡献者榜单', component: ContributorLeaderboard },
  { key: '5', icon: ReadOutlined, label: '开发者故事', component: DeveloperStories }
];
</script>

<style scoped>
.sider {
  box-shadow: 2px 0 8px #f0f1f2;
}

.menu {
  height: 100%;
}

.content-scroll {
  padding: 0 24px 24px;
  overflow-y: auto;
  flex: 1;
  background: #F9FAFB;
}
</style>
